/* @generated from adl module ferovinum.sourcecontracts.invoicelineitem */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.invoice_line_item` contract.
 */
export interface InvoiceLineItemSource {
  id: ferovinum_app_db.InvoiceLineItemId;
  invoiceId: ferovinum_app_db.InvoiceId;
  code: string;
  description: string;
  quantity: common.BigDecimal;
  quantitySuffix: (string|null);
  unitPrice: common.BigDecimal;
  vatPc: (common.BigDecimal|null);
  subtotal: common.BigDecimal;
  discountAmount: (common.BigDecimal|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeInvoiceLineItemSource(
  input: {
    id: ferovinum_app_db.InvoiceLineItemId,
    invoiceId: ferovinum_app_db.InvoiceId,
    code: string,
    description: string,
    quantity: common.BigDecimal,
    quantitySuffix: (string|null),
    unitPrice: common.BigDecimal,
    vatPc: (common.BigDecimal|null),
    subtotal: common.BigDecimal,
    discountAmount: (common.BigDecimal|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): InvoiceLineItemSource {
  return {
    id: input.id,
    invoiceId: input.invoiceId,
    code: input.code,
    description: input.description,
    quantity: input.quantity,
    quantitySuffix: input.quantitySuffix,
    unitPrice: input.unitPrice,
    vatPc: input.vatPc,
    subtotal: input.subtotal,
    discountAmount: input.discountAmount,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const InvoiceLineItemSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.invoicelineitem","decl":{"annotations":[{"value":{"modelName":"source__app_db.invoice_line_item","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.invoice_line_item` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InvoiceLineItemId"}},"parameters":[]}},{"annotations":[],"serializedName":"invoiceId","default":{"kind":"nothing"},"name":"invoiceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"InvoiceId"}},"parameters":[]}},{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"quantitySuffix","default":{"kind":"nothing"},"name":"quantitySuffix","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"unitPrice","default":{"kind":"nothing"},"name":"unitPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"vatPc","default":{"kind":"nothing"},"name":"vatPc","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"subtotal","default":{"kind":"nothing"},"name":"subtotal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"discountAmount","default":{"kind":"nothing"},"name":"discountAmount","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"InvoiceLineItemSource","version":{"kind":"nothing"}}};

export const snInvoiceLineItemSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.invoicelineitem", name:"InvoiceLineItemSource"};

export function texprInvoiceLineItemSource(): ADL.ATypeExpr<InvoiceLineItemSource> {
  return {value : {typeRef : {kind: "reference", value : snInvoiceLineItemSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.invoicelineitem.InvoiceLineItemSource" : InvoiceLineItemSource_AST
};
